import React, { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLocation, useHistory } from "react-router-dom";
import * as constants from "../../../utils/Constants";
import {
  Dropdown,
  DropdownButton,
} from "react-bootstrap";
import { useReactCountdown } from "use-react-countdown";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ViewJob = () => {
  const {
    state,
    filterDataCallback,
    searchCallBack,
    sortByCallBack,
    orderCallBack,
    pageCallBack,
  } = useLocation();
  const [jobStatus, setJobStatus] = useState("");
  const [jobStatusList, setJobStatusList] = useState([]);
  const loggedInUser = JSON.parse(localStorage.getItem("user"));
  var endDate = new Date(state?.jobAddedDate);
  endDate.setDate(endDate.getDate() + 2);
  const { days, hours, minutes, seconds } = useReactCountdown(endDate);
  useEffect(() => {
    window.scrollTo(0, 0);

    fetch(constants.JobStatusListUrl, {
      headers: {
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setJobStatusList(result.data);
      });
  }, []);

  const handleDownloadAttachment = (jobDescriptionFileName) => {
    if (jobDescriptionFileName) {
      var url = `${constants.DownloadAttachmentUrl}/${jobDescriptionFileName}`;
      fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
      })
        .then((res) => res.blob())
        .then((response) => {
          var fileDownload = require("js-file-download");
          fileDownload(response, `${state.jobDescriptionFileName}`);
        });
    }
  };

  const handleDownloadAttachmentEmail = (fileName) => {
    if (fileName) {
      var url = `${constants.DownloadAttachmentUrlEmail}/${fileName}`;
      fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
      })
        .then((res) => res.blob())
        .then((response) => {
          var fileDownload = require("js-file-download");
          fileDownload(response, `${state.emailReceivedFileName}`);
        });
    }
  };

  const handleStatusChange = (key, event) => {
    setJobStatus(key);
    fetch(`${constants.ChangeJobStatusUrl}/${state.jobPostId}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
      body: JSON.stringify({ jobStatus: key }),
    });
  };
  const history = useHistory();

  const backBtn = () => {
    history.push({
      pathname: "/list-job",
      state: "",
      filterDataCallback: filterDataCallback,
      searchCallBack: searchCallBack,
      sortByCallBack: sortByCallBack,
      orderCallBack: orderCallBack,
      pageCallBack: pageCallBack,
    });
  };

  const handleCallBack = () => {
    var url = `${constants.RecrutingAgentRequest}/${loggedInUser.userId}?jobPostId=${state.jobPostId}`;
    fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }).then((response) => response.json());
    //  .then((res) => {
    //      if (res.message) {
    toast.success(`✅Request sent successfully!`, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
    //        }
    //  })
  };
  return (
    <Fragment>
      <div className="form-group">
        <button
          id="go-back"
          color="primary"
          className="btn btn-primary"
          style={{
            backgroundColor: "#00ADEE",
            border: "none",
            marginTop: 0,
            marginBottom: 0,
            paddingLeft: "10px",
            paddingRight: "10px",
            paddingTop: "4px",
            paddingBottom: "4px",
          }}
          type="button"
          onClick={() => backBtn()}
        >
          <i class="fa fa-arrow-circle-o-left" style={{ fontSize: "25px" }} />
        </button>
      </div>
      <div className="row">
        <div className="col-xl-6 col-xxl-6">
          <div className="row">
            <div className="col-xl-12 col-lg-6">
              <div className="card  flex-lg-column flex-md-row ">
                {/* timer */}
                {loggedInUser.roles === "Recruitment Agent" &&
                  state.wishlistFlag === 1 && (
                    <div className="App" style={{ textAlign: "center" }}>
                      <h4>
                        Job will be removed from Worklist in {days}:{hours}:
                        {minutes}:{seconds}
                      </h4>
                    </div>
                  )}
                <div className="">
                  <div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-xl-12">
                          <div className="form-group ">
                            <div className="product-detail-content">
                              {/*Product details*/}
                              <div className="new-arrival-content pr">
                                <label
                                  style={{
                                    borderRadius: "10px",
                                    color: "white",
                                    height: "50px",
                                    padding: "10px",
                                  }}
                                  className="table display mb-4 dataTablesCard"
                                  align="center"
                                >
                                  Job Title : {state.jobTitle}
                                </label>
                                <p style={{ color: "black" }}>
                                  <span>Company : </span>&nbsp;
                                  {loggedInUser.roles === "Admin" && (
                                    <strong> {state.jobCompanyName}</strong>
                                  )}
                                  {loggedInUser.roles ===
                                    "Recruitment Agent" && (
                                    <button
                                      className="btn btn-primary"
                                      style={{
                                        border: "none",
                                        backgroundColor: "#00ADEE",
                                      }}
                                      onClick={handleCallBack}
                                    >
                                      Click to CallBack
                                    </button>
                                  )}
                                </p>
                                <hr />
                                <p style={{ color: "black" }}>
                                  {" Designation : "}
                                  <strong>{state.designation}</strong>
                                </p>
                                <hr />
                                <p style={{ color: "black" }}>
                                  {" Min Experience : "}{" "}
                                  <strong> {state.minExperience}</strong>
                                </p>
                                <hr />
                                <p style={{ color: "black" }}>
                                  {" Max Experience : "}{" "}
                                  <strong> {state.maxExperience}</strong>
                                </p>
                                <hr />
                                <p style={{ color: "black" }}>
                                  {" Min CTC : "}{" "}
                                  <strong>{state.minCtc}</strong>
                                </p>
                                <hr />
                                <p style={{ color: "black" }}>
                                  {" Max CTC : "}{" "}
                                  <strong>{state.maxCtc}</strong>
                                </p>
                                <hr />
                                <p style={{ color: "black" }}>
                                  {" Preferred Candidate Location: "}
                                  <strong>
                                    {state.preferredCandidateLocation.map(
                                      (pre) => (
                                        <span className="ml-2">{pre}</span>
                                      )
                                    )}
                                  </strong>{" "}
                                </p>
                                <hr />
                              </div>
                            </div>
                            <ToastContainer />
                          </div>
                          <div className="form-group">
                            <div className="new-arrival-content pr">
                              <label
                                style={{
                                  borderRadius: "10px",
                                  color: "white",
                                  height: "50px",
                                  padding: "10px",
                                }}
                                className="table display mb-4 dataTablesCard"
                                align="center"
                              >
                                Other Information
                              </label>
                              <p style={{ color: "black" }}>
                                <span>Qualification</span>
                                {" : "}{" "}
                                <strong>
                                  {/* {state.qualification?.map((qual) => (<span className='badge ml-2 badge-success light'>{qual}</span>))} */}
                                  {state.qualification}
                                </strong>{" "}
                              </p>
                              <hr />
                              <p style={{ color: "black" }}>
                                <span>Industries</span>
                                {" : "}
                                <strong>
                                  {" "}
                                  {state.industries.map((ind) => (
                                    <span className="ml-2">{ind}</span>
                                  ))}
                                </strong>{" "}
                              </p>
                              <hr />
                              <p style={{ color: "black" }}>
                                <span>State</span>
                                {" : "} <strong>{state.state}</strong>{" "}
                              </p>
                              <hr />
                              <p style={{ color: "black" }}>
                                <span>City</span>
                                {" : "} <strong>{state.city}</strong>{" "}
                              </p>
                              <hr />
                              <p style={{ color: "black" }}>
                                <span>Work Type</span>
                                {" : "}
                                <strong>{state.remoteLocation}</strong>
                              </p>
                              <hr />
                              <p style={{ color: "black" }}>
                                <span>Open Positions</span>
                                {" : "}
                                <strong>{state.numberOfPositionOpen}</strong>
                              </p>
                              <hr />
                              <p style={{ color: "black" }}>
                                <span>Job End Date</span>
                                {" : "}
                                <strong>{state.jobEndDate}</strong>
                              </p>
                              <hr />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-6 col-xxl-6">
          <div className="row">
            <div className="col-xl-12">
              <div className="card profile-card">
                <div className="card-header flex-wrap border-0 pb-0">
                  {loggedInUser.roles !== "Recruitment Agent" && (
                    <Link
                      className="btn btn-primary btn-md"
                      style={{ backgroundColor: "#00ADEE", border: "none" }}
                      to={{
                        pathname: "/add-job",
                        state: state,
                      }}
                    >
                      <i className="fa fa-edit mr-2" />
                      Edit Job
                    </Link>
                  )}{" "}
                  &nbsp;&nbsp;
                  {((loggedInUser.roles === "Recruitment Agent" &&
                    state.wishlistFlag === 1) ||
                    loggedInUser.roles !== "Recruitment Agent") && (
                    <Link
                      className="btn btn-primary btn-md"
                      style={{ backgroundColor: "#00ADEE", border: "none" }}
                      to={{
                        pathname: "/apply-job",
                        state: state,
                      }}
                    >
                      <i className="fa fa-plus-square-o mr-2" />
                      Add Candidate
                    </Link>
                  )}
                  &nbsp;&nbsp;
                  <Link
                    className="btn btn-primary btn-md"
                    style={{ backgroundColor: "#00ADEE", border: "none" }}
                    to={{
                      pathname: "/applied-candidates",
                      state: state,
                    }}
                  >
                    <i className="fa fa-eye mr-2" />
                    Profiles Submitted
                  </Link>
                  &nbsp;&nbsp;
                  {loggedInUser.roles === "Recruitment Agent" ? (
                    <div style={{ marginTop: "10px" }}>
                      <button
                        style={{
                          border: "none",
                          backgroundColor: "#00ADEE",
                          textAlign: "center",
                        }}
                        className="btn btn-primary btn-md"
                      >
                        {jobStatus || state.jobStatus}
                      </button>
                    </div>
                  ) : (
                    <div style={{ marginTop: "10px" }}>
                      <DropdownButton
                        id="dropdown-basic-button"
                        variant="success"
                        onSelect={handleStatusChange}
                        title={jobStatus || state.jobStatus}
                        style={{ color: "#00ADEE" }}
                      >
                        {jobStatusList?.map((item, index) => {
                          return (
                            <Dropdown.Item key={index} eventKey={item}>
                              {item}
                            </Dropdown.Item>
                          );
                        })}
                      </DropdownButton>
                    </div>
                  )}
                </div>
                <div className="card-body">
                  <div className="new-arrival-content pr">
                    <label
                      style={{
                        borderRadius: "10px",
                        color: "white",
                        height: "50px",
                        padding: "10px",
                      }}
                      className="table display mb-4 dataTablesCard"
                      align="center"
                    >
                      Job Description
                    </label>
                    <div className="col-lg-12">
                      {loggedInUser?.roles === "Admin" && (
                        <div className="form-group row">
                          <p style={{ color: "black" }}>
                            <span>Commission for Job</span>
                            {" : "}
                            <strong>{state.commissionForJob}{state.commissionType === 'Percentage' ? '%' : '/-'}</strong>
                          </p>
                          <hr />
                        </div>
                      )}
                      <div className="form-group row">
                        <p style={{ color: "black" }}>
                          <span>Key Skills&nbsp;{" : "} </span>
                          {/* {state.keySkills.map((skill) => (<span className='badge ml-2 badge-success light'>{skill}</span>))} */}
                          {state.keySkills}
                        </p>
                      </div>
                      <div className="form-group row">
                        <p style={{ color: "black" }}>Description: </p>
                        <div
                          type="text"
                          className="col-lg-12 pl-2"
                          style={{
                            marginLeft: 5,
                          }}
                          dangerouslySetInnerHTML={{
                            __html: state?.jobDescription,
                          }}
                        />
                        {state.jobDescriptionFileName && (
                          <button
                            style={{
                              border: "none",
                              backgroundColor: "#00ADEE",
                              textAlign: "center",
                              marginLeft: 5,
                            }}
                            className="btn btn-primary btn-md"
                            onClick={() =>
                              handleDownloadAttachment(
                                state.jobDescriptionFileName
                              )
                            }
                          >
                            Download Description
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                  {loggedInUser?.roles === "Admin" && (
                    <div className="new-arrival-content pr">
                      <label
                        style={{
                          borderRadius: "10px",
                          color: "white",
                          height: "50px",
                          padding: "10px",
                        }}
                        className="table display mb-4 dataTablesCard"
                        align="center"
                      >
                        Email Received From Client
                      </label>
                      <div className="col-lg-12">
                        <div className="form-group row">
                          <p style={{ color: "black" }}>
                            <span>Email Received Date</span>
                            {" : "}
                            <strong>{state.emailReceivedDate}</strong>
                          </p>
                        </div>
                        <div className="form-group row">
                          <p style={{ color: "black" }}>Description: </p>
                          <div
                            type="text"
                            className="col-lg-12 pl-2"
                            style={{
                              marginLeft: 5,
                            }}
                            dangerouslySetInnerHTML={{
                              __html: state?.emailReceivedFromClient,
                            }}
                          />
                          {state.emailReceivedFileName && (
                            <button
                              style={{
                                border: "none",
                                backgroundColor: "#00ADEE",
                                textAlign: "center",
                                marginLeft: 5,
                              }}
                              className="btn btn-primary btn-md"
                              onClick={() =>
                                handleDownloadAttachmentEmail(
                                  state.emailReceivedFileName
                                )
                              }
                            >
                              Download Description
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
export default ViewJob;
